import { Controller } from '@hotwired/stimulus'
import { application } from './application'

let asyncControllerLoaded = false

export default class extends Controller {
  connect () {
    if (!asyncControllerLoaded) {
      asyncControllerLoaded = true
      import('./lod_viewer_controller_async').then((controller) => {
        application.load([{ identifier: 'lod-viewer', controllerConstructor: controller.default }])
      }, () => { })
    }
  }
}
